/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rating_SubmitInputs */

const en_directory_detail_rating_submit = /** @type {(inputs: Directory_Detail_Rating_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit rating`)
};

const zh_directory_detail_rating_submit = /** @type {(inputs: Directory_Detail_Rating_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交评分`)
};

/**
* | output |
* | --- |
* | "Submit rating" |
*
* @param {Directory_Detail_Rating_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rating_submit = /** @type {((inputs?: Directory_Detail_Rating_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rating_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rating_submit(inputs)
	return zh_directory_detail_rating_submit(inputs)
});
export { directory_detail_rating_submit as "directory.detail.rating_submit" }